import React from 'react';
import styled from 'styled-components';

import { useDispensaryDisclaimer } from 'src/dispensary/hooks/use-dispensary-disclaimer';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import DisclaimerText from 'src/dispensary/components/disclaimer-text';
import { DutchiePrivacyFooter } from 'src/dispensary/core-menu/components/dutchie-privacy-footer';
import { InlineCategoriesList } from 'src/components/inline-categories-list';
import { CategoryPageBelowList } from 'src/dispensary/category/category-below-list';
import { useRemoteComponent, RemoteComponentSlot } from 'hooks/use-remote-component';

export default function CoreMenuFooter({
  displayDisclaimer = true,
  hideCategories,
}: {
  displayDisclaimer?: boolean;
  hideCategories?: boolean;
}): JSX.Element | null {
  const { dispensary } = useDispensary();
  const { disclaimerIsBlank, disclaimerTextHtml } = useDispensaryDisclaimer();

  const displayDisclaimerAbove = displayDisclaimer && !disclaimerIsBlank && hideCategories;
  const displayDisclaimerBelow = displayDisclaimer && !disclaimerIsBlank && !hideCategories;

  const ResolvedFooter = useRemoteComponent(RemoteComponentSlot.Footer, { fallback: DutchiePrivacyFooter });

  if (!dispensary) {
    return null;
  }

  return (
    <>
      {displayDisclaimerAbove && <DisclaimerText m='50px auto' html={disclaimerTextHtml} />}

      {!hideCategories && <InlineCategoriesList />}

      <CategoryPageBelowList />

      {displayDisclaimerBelow && (
        <BottomDisclaimerContainer>
          <DisclaimerText m='50px auto' className='disclaimer-text' html={disclaimerTextHtml} />
        </BottomDisclaimerContainer>
      )}

      <ResolvedFooter />
    </>
  );
}

const BottomDisclaimerContainer = styled.div`
  display: flex;
  width: 100%;
  background: var(--dcm-footer-bg);
  ${({ theme }) => theme.breakpoints.down('sm')} {
    .disclaimer-text {
      margin: var(--dcm-footer-disclaimer-margin-sm);
    }
    background: var(--dcm-footer-bg-sm);
  }
`;
